import { render, staticRenderFns } from "./AccountNotice.vue?vue&type=template&id=22726030"
import script from "./AccountNotice.vue?vue&type=script&lang=js"
export * from "./AccountNotice.vue?vue&type=script&lang=js"
import style0 from "./AccountNotice.vue?vue&type=style&index=0&id=22726030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports